<template>
  <v-dialog v-model="dialog" width="500" persistent>
    <v-card class="pa-0">
      <v-card-title class="accent--text">
        {{ $t("expiration.expiredOrder") }}
      </v-card-title>

      <v-card-text class="mt-2">
        <span class="black--text checkout-h4">{{ $t("expiration.text") }}</span>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          width="100"
          height="40"
          rounded
          outlined
          @click="close"
        >
          {{ $t("expiration.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapGetters(["expirationDialog", "eventId"]),
  },
  methods: {
    async close() {
      this.$router.push({
        name: "Cart",
        params: { event: this.eventId },
        query: this.$route.query,
      });
      this.$store.dispatch("resetCheckout", this.eventId);
      await this.$store.dispatch("getProductsAndSectors", {
        event: this.eventId,
        coupon: this.$route.query.c,
      });
    },
  },
  watch: {
    expirationDialog(v) {
      this.dialog = v;
    },
  },
};
</script>
